import { HttpResponse, HttpStatusEnum } from '@core/api';
import { FormatterHelper } from '@shared/helpers';

function mapAutosuggestUsers(data: any): HttpResponse<{ id: number; name: string; email: string }[]> {
    return {
        status: HttpStatusEnum.SUCCESS,
        data: data.users.map((user: any) => ({
            id: user.id,
            name: FormatterHelper.computeUserFullName(user.firstName, user.lastName),
            email: user.email,
        })),
    };
}

function mapAutosuggestOrganizations(data: any): HttpResponse<{ id: number; name: string }[]> {
    return {
        status: HttpStatusEnum.SUCCESS,
        data: data.organizations.map((organization: any) => ({
            id: organization.id,
            name: organization.name,
        })),
    };
}

function mapAutosuggestLaboratories(data: any): HttpResponse<{ id: number; name: string }[]> {
    return {
        status: HttpStatusEnum.SUCCESS,
        data: data.laboratories.map((laboratory: any) => ({
            id: laboratory.id,
            name: laboratory.name,
        })),
    };
}

function mapSuggestStrains(data: any): HttpResponse<{ id: number; name: string }[]> {
    return {
        status: HttpStatusEnum.SUCCESS,
        data: data.strains.map((strain: any) => ({
            id: strain.strain.id,
            name: strain.strain.name,
        })),
    };
}

export const AutosuggestMapper = {
    mapAutosuggestUsers,
    mapAutosuggestOrganizations,
    mapAutosuggestLaboratories,
    mapSuggestStrains,
};
